import { useInfiniteQuery } from '@tanstack/react-query';
import { getProcessedTimesheets } from '../Services/ProcessedTimesheetService';

const useGetProcessedTimesheets = (params, options) =>
    useInfiniteQuery({
        queryKey: ['processedTimesheets', params],
        queryFn: ({ pageParam: offset = 0 }) => getProcessedTimesheets({ ...params, offset }),
        getNextPageParam: (lastResponse) => {
            const displayedItems = lastResponse.offset + lastResponse.numberReturned;
            const nextOffset =
                displayedItems < lastResponse.totalCount
                    ? lastResponse.offset + params.pageSize
                    : undefined;
            return nextOffset;
        },
        ...options,
    });

export default useGetProcessedTimesheets;
